import * as Jsll from "../../ShellCommon/logger/jsll-types";
export type WindowWithAwa = Window & { awa: Jsll.AwaStatic };
export let registerUnloadListenerToFlushEvents = (windowObject: WindowWithAwa) => {
  // Make a last ditch effort to submit queued events as the window is unloaded.
  windowObject.addEventListener("beforeunload", () => {
    windowObject.awa.vortexEvents.batchQueuedEvents();
  });

  windowObject.addEventListener("unload", () => {
    windowObject.awa.vortexEvents.batchQueuedEvents();
  });
};
